
import { useCatalogPageContext } from "shared/catalog/CatalogPageContext/useCatalogPageContext";

import { CatalogGrid } from "../CatalogGrid";

import { CatalogProductCardComingSoon } from "./CatalogProductCardComingSoon";

export const ComingSoonCatalog = (props: {
  layoutHasFilters?: boolean
}) => {
  const { filteredComingSoonEntries } = useCatalogPageContext();

  return (
    <>
    {(filteredComingSoonEntries?.length || 0) > 0 && (
      <CatalogGrid layoutHasFilters={props.layoutHasFilters}>
        {filteredComingSoonEntries?.map((product) => (
          <CatalogProductCardComingSoon
            key={product.slug}
            brand={product.brand}
            slug={product.slug}
            modelName={product.entryName}
            image={product.picture}
            releaseDate={product.releaseDate}
          />
        ))}
      </CatalogGrid>
    )}
    </>
  );
};
